/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class HealthService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Health
     * @returns any Successful Response
     * @throws ApiError
     */
    public health(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/health',
        });
    }

    /**
     * Readiness
     * @returns string Successful Response
     * @throws ApiError
     */
    public readiness(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/health/ready',
        });
    }

    /**
     * Search Readiness
     * Search-index diagnostics for operators and alerting — not a k8s probe.
     * @returns string Successful Response
     * @throws ApiError
     */
    public searchReadiness(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/health/search',
        });
    }

}
